import React from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { Case } from "../../../helpers/interfaces";

type IProps = {
    show: boolean;
    isSaving: boolean;
    caseToDelete?: Case;
    onHide: () => void;
    onDelete: (caseToDelete: Case | undefined) => void;
}
const DeleteCaseModal = (props: IProps) => {
    return (
        <Modal show={props.show}
               onHide={props.onHide}
               dialogClassName="modal-dialog-centered">
            <Modal.Header
                onHide={props.onHide} closeButton>
                <h4 className="modal-title">
                    Delete {" "}
                    <span
                        className="text-danger">
                        {props.caseToDelete?.name}
                    </span> ?
                </h4>
            </Modal.Header>
            <Modal.Body>
                <p>Are you sure you want to delete this case?</p>
            </Modal.Body>
            <Modal.Footer>
                {props.isSaving && <Spinner className="m-2"/>}
                <Button
                    disabled={props.isSaving}
                    onClick={() => props.onHide()} variant="secondary">
                    Cancel
                </Button>
                <Button
                    disabled={props.isSaving}
                    onClick={() => props.onDelete(props.caseToDelete)} variant="danger">
                    Delete
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default DeleteCaseModal;